import React from 'react'
import { Controller } from 'react-hook-form'

function CheckBoxUp(props) {
    return (
        <div className='flex w-full md:px-2'>
        <Controller
            control={props.method.control}
            name={props.methodName}
            render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState,
            }) => {
                return (
                < input
                    onChange={(e) =>{
                        if(e.target.checked){
                            onChange(e.target.value)
                        }
                        else if(!e.target.checked){
                            onChange()
                        }
                        if(props.onChange){
                            props.onChange(e.target.value)
                        }
                    }} 
                    type="checkbox"
                    className={`w-4 h-4 mt-1`}
                    id={props.id} 
                    value={props.value}
                    checked={props.value === value}
                    ref={ref}
                />
             )}}

        />
        < label className='ml-2 text-md font-light'>{props.label}</label>
    </div>


    )
}

export default CheckBoxUp